import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import _ from "lodash";

import "@ant-design/compatible/assets/index.css";

import { Collapse } from "antd";

import CreateSelectForm from "../../components/Form/CreateSelectForm";
import AutoCompleteFormItem from "../../components/FormItem/AutoCompleteFormItem";
import DetailPermissionForm from "../../components/Form/PermissionForm/DetailPermissionForm";
import RoleProjectPermission from "../../components/RoleManager/RolePermission/RoleProjectPermission";
import RoleIndexPermission from "../../components/RoleManager/RolePermission/RoleIndexPermission";
import { rolesGetUserRoleData } from "../../api/role";

//Util function
import {
  updateSendValuesHandler,
  detailedPermissionFormSetFields,
} from "../../components/RoleManager/Utils/Utils";
import SelectItem from "../../components/FormItem/SelectItem";

const { Panel } = Collapse;

class RoleManager extends Component {
  state = {
    loading: false,
    visible: false,
    create: true,
    selectData: null,
    selectHmg: null,
    fromData: null,
    selectedMainRoleId: null,
    filteredRoles: null,
    mainRole: null,
    endUserAccess:false,
    rolePermission:true
  };

  async componentDidMount() {
    // if (!this.props.api.rolesGetData) {
    //   await this.props.rolesGet();
    // }
    if (!this.props.api.mainRolesGetData) {
      await this.props.mainRolesGet();
      await this.props.rolesListGet();
    }if(this.props.api.rolesListGetData?.data){
      this.setState({filteredRoles:this.props.api.rolesListGetData.data})
    }if(await this.props.api.rolesGetData?.data){
      await this.props.rolesGet();
    }

  }

  formOneSaveFormRef = (formRef) => {
    this.formOneFormRef = formRef;
  };
  formTwoSaveFormRef = (formRef) => {
    this.formTwoFormRef = formRef;
    this.formTwoSetFieldsFunction();
  };

  customFormRest = () => {
    if (this.formOneFormRef) {
      this.formOneFormRef.setFieldsValue({
        role_name: "",
      });
    }
  };

  formOneSubmitFunction = async (value) => {
    if (this.state.create) {
      await this.props.roleCreate(value);
      this.formOneFormRef.resetFields();
      await this.props.rolesGet();
    } else {
      this.formTwoSetFieldsFunction();
    }
  };

  formTwoSetFieldsFunction = () => {
    if (this.formTwoFormRef) {
     const userAccess= detailedPermissionFormSetFields(this.formTwoFormRef, this.state.selectData);
     this.setState({endUserAccess:userAccess})
    }
  };

  formTwoSubmit = async (values) => {
    const sendValues = await updateSendValuesHandler(values);
    if (await this.props.roleUpdate(sendValues)) {
      // await this.props.rolesGet();
    }
  };

  rolesByMainRoleSelection = async () => {

    const rolesByMainRole = await this.props.rolesGetByMainRoleId(this.selectedMainRoleId)
    const filteredRoles = rolesByMainRole?.data?.filter(
      (e) => e?.main_role_id?._id === this.selectedMainRoleId,
    );

    filteredRoles.sort((a, b) =>
      a?.role_name?.toLowerCase().localeCompare(b?.role_name?.toLowerCase()),
    );
    this.setState({
      filteredRoles: filteredRoles,
    });
    return filteredRoles;
  }

  autoCompleteOneChangeFunction = async (value,newRole=false) => {

    if (value === undefined) {
      value = "";
    }
    if(newRole === true){
      await this.props.rolesListGet();
      if(this.props.api.rolesListGetData?.data){
        this.setState({filteredRoles:this.props.api.rolesListGetData.data})
      }
    }
    const role = this.state.filteredRoles.find(item => item.role_name === value)
    if(role?._id){
      const roleDataResponse = await rolesGetUserRoleData(role._id);
      const result = roleDataResponse.data
      if (result) {
        const send_data = [];
        this.selectedMainRoleId =result.main_role_id?._id;
        this.formOneFormRef.setFieldsValue({
          main_role_name: result.main_role_id?._id,
          role_name: result.role_name,
        });
        this.roleDataSourceHandler()
        const data = { role_id: role._id }
        const usersByRole = await this.props.userGetById(data);
        if (usersByRole) {
          const usersByRoleData = usersByRole.data;
          if (usersByRoleData) {
            usersByRoleData.forEach((b) => {
              if (b.hotels) {
                b.hotels.forEach((ba) => {
                  if (ba.primary_hmg_id) {
                    const aaaa = _.find(send_data, {
                      primary_hmg_id: ba.primary_hmg_id._id,
                    });

                    if (!aaaa) {
                      send_data.push({
                        primary_hmg_id: ba.primary_hmg_id._id,
                        hmg_name: ba.primary_hmg_id.hmg_name,
                        project_name: ba.primary_hmg_id.project_name,
                        indexes: ba.primary_hmg_id.indexes,
                      });
                    }
                  }
                  if (ba.secondary_hmg_id) {
                    const bbbb = _.find(send_data, {
                      primary_hmg_id: ba.secondary_hmg_id._id,
                    });

                    if (!bbbb) {
                      send_data.push({
                        primary_hmg_id: ba.secondary_hmg_id._id,
                        hmg_name: ba.secondary_hmg_id.hmg_name,
                        project_name: ba.secondary_hmg_id.project_name,
                        indexes: ba.secondary_hmg_id.indexes,
                      });
                    }
                  }
                  if (ba.third_hmg_id) {
                    const cccc = _.find(send_data, {
                      primary_hmg_id: ba.third_hmg_id._id,
                    });

                    if (!cccc) {
                      send_data.push({
                        primary_hmg_id: ba.third_hmg_id._id,
                        hmg_name: ba.third_hmg_id.hmg_name,
                        project_name: ba.third_hmg_id.project_name,
                        indexes: ba.third_hmg_id.indexes,
                      });
                    }
                  }
                  if (ba.fourth_hmg_id) {
                    const dddd = _.find(send_data, {
                      primary_hmg_id: ba.fourth_hmg_id._id,
                    });

                    if (!dddd) {
                      send_data.push({
                        primary_hmg_id: ba.fourth_hmg_id._id,
                        hmg_name: ba.fourth_hmg_id.hmg_name,
                        project_name: ba.fourth_hmg_id.project_name,
                        indexes: ba.fourth_hmg_id.indexes,
                      });
                    }
                  }
                });
              }
            });
          }
        }
        this.setState({
          create: false,
          selectData: result,
          selectHmg: send_data,
        });
        if (this.formTwoFormRef) {
          const userAccess = detailedPermissionFormSetFields(this.formTwoFormRef, this.state.selectData);
          this.setState({endUserAccess:userAccess})
        }
      }
   } else {
      this.setState({ create: true, selectData: null, selectHmg: null });
    }
  };

  autoCompleteOneSelect = async (value, option) => {
    console.log('autoCompleteOneSelect',value)
    // await this.autoCompleteOneChangeFunction(value);
  };

  autoCompleteOneChange = (value) => {
    if (value) {
      const result = this.props.api.rolesListGetData.data.find(
        (e) => e.role_name.toUpperCase().trim() === value.toUpperCase().trim(),
      );
      if (result) {
        this.setState({ create: false, selectData: result });
        this.formOneFormRef.setFieldsValue({
          main_role_name: result.main_role_id ? result.main_role_id : undefined,
          role_name: result.role_name,
        });
      } else {
        this.setState({ create: true, selectData: null, dataOne: null });
      }
    } else {
      this.setState({ create: true, selectData: null, dataOne: null });
    }
  };

  onChangeMainRoleHandler = (value, label) => {
    if (value === undefined) {
      value = "" 
      this.selectedMainRoleId=''
    this.autoCompleteOneChangeFunction()
    } 
    this.customFormRest();
    this.setState({
      selectedMainRoleId: null,
      filteredRoles: null,
    });
    if(label?.children){
      const main_role= label.children
    //  this.onSelectMainRoleHandler(value,main_role)
      this.selectedMainRoleId= label.value
    }
    this.roleDataSourceHandler()
  };

  roleDataSourceHandler=()=>{
    let roleOptionsData= this.props.api.rolesListGetData.data
      if(this.selectedMainRoleId){
        roleOptionsData=this.props.api.rolesListGetData.data.filter(item => item.main_role_id ===this.selectedMainRoleId)

        roleOptionsData.sort((a, b) =>
        a?.role_name?.toLowerCase().localeCompare(b?.role_name?.toLowerCase()),
      );
      }
    this.setState({filteredRoles:roleOptionsData})
 }

  onSelectMainRoleHandler = async (value, main_role) => {
    if (main_role === undefined) main_role = "";
    this.mainRole = main_role
    const selectedMainRole = this.props.api.mainRolesGetData?.data?.find(
      (e) => e?.main_role_name?.toLowerCase() === main_role?.toLowerCase(),
    );
    this.selectedMainRoleId = selectedMainRole?._id;
    this.setState({ selectedMainRoleId: this.selectedMainRoleId })
    await this.rolesByMainRoleSelection();

  };

  sortMainRoleData = () =>
    this.props.api.mainRolesGetData?.data?.sort((a, b) =>
      a?.main_role_name
        ?.toLowerCase()
        .localeCompare(b?.main_role_name?.toLowerCase()),
    );

  formOnFinish = async (values) => {
    const apiData = {};
    apiData.role_name = values.role_name;
    apiData.main_role_id = this.selectedMainRoleId;
    if (this.state.create) {
      await this.props.roleCreate(apiData);
      await this.autoCompleteOneChangeFunction(values.role_name,true)
    }
  };

  formOnFinshFailed = (errInfo) => {
    if (errInfo) {
      return;
    }
  };

  indexPermissionOnChange= (value) =>{
    this.setState({indexAccess:value})
    this.formTwoFormRef.setFieldsValue({index_permission_access:value})
  }

  render() {
    const mainRoleFormItem = {
      label: "Main Role",
      name: "main_role_name",
      message: "Please Select Main Role",
    };

    const useRoleFormItem = {
      label: "User Role",
      name: "role_name",
      message: "Please Select or Enter User Role",
    };

    const autoCompleteRoles = {
      autoCompleteOneChange: this.autoCompleteOneChangeFunction,
      autoCompleteOneSelect: this.autoCompleteOneSelect,
    };
    let isAdmin = this.props?.api?.permission?.sm_solution_access ?? false;
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="Role Permission" key="1_1" arrow="right">
                <div className="is_form_1">
                  {
                    this.props.api.mainRolesGetData && this.props.api.rolesListGetData && (
                      <CreateSelectForm
                        onFinishFailed={this.formOnFinshFailed}
                        onFinish={this.formOnFinish}
                        formData={this.formOneSaveFormRef}
                        createStatus={this.state.create}
                      >
                         <SelectItem
                        formItem={mainRoleFormItem}
                        dataSource={this.sortMainRoleData()}
                        selectChange={this.onChangeMainRoleHandler}
                        placeholder="Select Main Role"
                      />
                        <AutoCompleteFormItem
                          autoComplete={autoCompleteRoles}
                          dataSource={this.state.filteredRoles}
                          formItem={useRoleFormItem}
                          placeholder="Select or Enter User Role"
                        />
                      </CreateSelectForm>
                    )}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>

            {this.state.selectData ? <h3>{this.state.selectData.role_name}</h3> : null}

            {this.state.selectData ? (
              <DetailPermissionForm
                onFinish={this.formTwoSubmit}
                onFinishFailed={this.formOnFinshFailed}
                updateInitialValue={this.state.selectData}
                formData={this.formTwoSaveFormRef}
                selectHmg={this.state.selectHmg}
                isAdmin={isAdmin}
              >
               
              </DetailPermissionForm>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  mainRolesGet: () => dispatch(actions.mainRolesGet()),
  rolesListGet: () => dispatch(actions.rolesListGet()),
  rolesGet: (data) => dispatch(actions.rolesGet(data)),
  rolesGetByMainRoleId: (id) => dispatch(actions.rolesGetByMainRoleId(id)),
  roleCreate: (data) => dispatch(actions.roleCreate(data)),
  roleUpdate: (data) => dispatch(actions.roleUpdate(data)),
  userGetById: (data) => dispatch(actions.userGetById(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleManager);
